import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import { Box, Button, Chip, IconButton, Typography } from "@mui/material";
import { Delete, Edit, RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../libs/core/components/data-table";
import { useGetTeamsQuery, useDeleteTeamMutation } from "./api/teamApi";
import { TeamProfile } from "./types/team";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import AddEditTeamProfile from "./components/AddEditTeam";
// import AddEditTeamProfile from "./components/AddEditTeamProfile";

const TeamProfileManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState<TeamProfile | null>(null);
  const navigate = useNavigate();

  const { data: profiles, isLoading, isError, isFetching } = useGetTeamsQuery();
  const [deleteTeamProfile] = useDeleteTeamMutation();

  const columns: Array<MRT_ColumnDef<TeamProfile>> = [ 
    {
      header: "Full Name",
      accessorKey: "full_name",
      size: 150,
    },
    {
      header: "Position",
      accessorKey: "position",
      size: 150,
    },
    {
      header: "Bio",
      accessorKey: "bio",
      size: 300,
    },
    {
      header: "Image",
      accessorKey: "profile_image",
      size: 80,
      Cell({ row: { original } }) {
        return (
          <img
            src={`${original.profile_image}`}
            alt="Profile"
            width={60}
            style={{ borderRadius: 6 }}
          />
        );
      },
    },
  ];

  return (
    <Box>
      <DataTable<TeamProfile>
        toolbar={
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" gap={3} alignItems="center" flex="1">
              <Typography variant="h6">Team Profiles</Typography>
              <Chip
                color="primary"
                variant="outlined"
                label={`${profiles?.data?.length ?? 0} Profiles`}
              />
            </Box>
            <Button
              onClick={() => {
                setSelectedProfile(null);
                setOpenDialog(true);
              }}
              sx={{ minWidth: "200px" }}
              variant="contained"
            >
              Add New Profile
            </Button>
          </Box>
        }
        list={profiles?.data ?? []}
        count={profiles?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row?.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        renderRowActions={(row) => (
          <Box display={"flex"} gap={1}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProfile(row);
                setOpenConfirmModal(true);
              }}
            >
              <Delete />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProfile(row);
                setOpenDialog(true);
              }}
            >
              <Edit />
            </IconButton>
        
          </Box>
        )}
        pagination={pagination}
        onPaginationChange={setPagination}
      />

      <AddEditTeamProfile
        open={openDialog}
        profile={selectedProfile}
        setModalOpen={setOpenDialog}
      />

      {selectedProfile && (
        <ConfirmModal
          type="primary"
          title="Delete Profile"
          message={`Are you sure you want to delete '${selectedProfile.full_name}'?`}
          modalOpen={openConfirmModal}
          setModalOpen={setOpenConfirmModal}
          onOk={() => {
            deleteTeamProfile(selectedProfile.id.toString());
            setOpenConfirmModal(false);
            setSelectedProfile(null);
          }}
        />
      )}
    </Box>
  );
};

export default TeamProfileManager;
